'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './requested-user-list.routes';

export class RequestedUserListComponent {
  constructor(RequestedUserService, dialogs, Auth, $stateParams) {
    'ngInject';

    this.RequestedUserService = RequestedUserService;

    this.dialogs = dialogs;
    this.isAdmin = Auth.isAdminSync;
    this.Auth = Auth;

    this.type = $stateParams.type;

    this.RequestedUserService.query(acccounts => {
      this.users = acccounts.filter(account => account.userTargetType == this.type);
    });
  }

  block(user) {
    var that = this;
    var userStr = "<br/><br/><b>" + user.firstName + ' ' + user.lastName + "</b>";
    var dlg = this.dialogs.confirm("Block Request", "Do you really want to block this request and thus delete this prospective user?" + userStr);
    dlg.result.then(() => {
      /* Delete the user */
      that.RequestedUserService.delete({id: user._id},
        () => {
          that.users = that.users.filter(function( obj ) {
            return obj._id !== user._id;
          });
        },
        err => {
          alert("Could not delete document");
        });
    }, () => {
      // Cancel
    });
  }

  approve(user) {
    var that = this;
    var userStr = "<br/><br/><b>" + user.firstName + ' ' + user.lastName + "</b>";
    var dlg = this.dialogs.confirm("Approve Request", "Do you want to approve this request?" + userStr);
    dlg.result.then(() => {
      that.RequestedUserService.approve({id: user._id}, {},
        () => {
          that.dialogs.notify("The Request has been approved.",
            "The prospective user will receive an email with the instructions on how to activate the account.");
          that.users = that.InvitedUserService.query();
        },
        err => {
          alert("Could not approve account");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduu.ap.admin.invitedUserList', [uiRouter])
  .config(routes)
  .component('requestedUserList', {
    template: require('./requested-user-list.html'),
    controller: RequestedUserListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/admin/requested-user-list/requested-user-list.component.js